import script from "./WorkloadUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkloadUpdateModal.vue?vue&type=script&setup=true&lang=ts"

import "./WorkloadUpdateModal.vue?vue&type=style&index=0&id=d6f8c972&lang=css"

const __exports__ = script;

export default __exports__